import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Icon } from "@/lib/icons";
import { Modal, Textarea, Button } from "@/components/kit";

// Standing "report what happened" launcher. Pre-fills screen + user (never asks them
// to retype); submits a short description that routes to Super Admins (in-app + email).
export function ReportIssue({ screen, variant = "sidebar" }) {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (!text.trim()) return toast.error("Please describe what happened.");
    setSaving(true);
    try {
      await api.post("/feedback", { text, screen: screen || document.title || "App" });
      toast.success("Thanks — your report was sent to the team.");
      setText(""); setOpen(false);
    } catch (e) {
      toast.error("Could not send. Please try again.");
    } finally { setSaving(false); }
  };

  const trigger =
    variant === "sidebar" ? (
      <button data-testid="report-issue-btn" onClick={() => setOpen(true)}
        className="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-cream/75 hover:text-cream hover:bg-cream/10 text-[14px]">
        <Icon name="MessageSquareWarning" className="w-4 h-4" /> Report an issue
      </button>
    ) : (
      <button data-testid="report-issue-btn" onClick={() => setOpen(true)}
        className="w-full flex items-center justify-center gap-2 px-3 py-2.5 rounded-xl border border-ink/15 text-ink/75 hover:border-maroon/40 text-[14px] font-semibold">
        <Icon name="MessageSquareWarning" className="w-4 h-4" /> Report an issue
      </button>
    );

  return (
    <>
      {trigger}
      <Modal open={open} onClose={() => setOpen(false)} title="Report an issue" data-testid="report-issue-modal"
        footer={<Button data-testid="report-issue-submit" variant="gold" onClick={submit} disabled={saving}>{saving ? "Sending…" : "Send report"}</Button>}>
        <p className="text-[13px] text-ink/55 mb-3">Tell us what happened on <span className="font-semibold">{screen || "this screen"}</span>. We already know who you are and where you were — just describe it.</p>
        <Textarea data-testid="report-issue-text" value={text} onChange={(e) => setText(e.target.value)} rows={5} autoFocus placeholder="Describe what happened…" />
      </Modal>
    </>
  );
}
